export class ContactsResources {
  public readonly contacts = 'Контакты';
  public readonly workScheduleStart = 'Работаем пн – пт: 9.00 – 18.00';
  public readonly workScheduleEnd = 'до ';
  public readonly viber = 'Viber';
  public readonly telegram = 'Telegram';
  public readonly post = 'Почта';
}
